import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const WelcomeSectionWrapper = styled.div`
    margin-left: auto;
    max-width: 434px;
    padding-bottom: 70px;
    position: relative;
    width: 100%;
`;

export const WelcomeSectionHeader = styled.div<{ isMultiLine: boolean }>(
    ({ isMultiLine }) => css`
        align-items: flex-end;
        display: flex;
        gap: 22px;
        margin-bottom: 30px;

        ${isMultiLine &&
        css`
            align-items: center;
            margin-bottom: 16px;
        `}
    `,
);

export const NicoleImageWrapper = styled.div`
    padding-bottom: 12px;
`;

export const WelcomeTitle = styled(Typography.TextH1_36_52)``;

export const PointsList = styled.div`
    margin: 16px 0;
`;

export const PointWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export const TickWrapper = styled.div`
    padding: 5px;
`;

export const BoldText = styled.span(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
    `,
);

export const PatternWrapper = styled.div`
    position: absolute;
    bottom: -28px;
    right: -116px;
`;
